module.exports = __webpack_public_path__ + "img/stokenet.cb8773e0.svg";